import React, { useRef, useEffect, useMemo } from "react";
import breakDownGraphConfig from "../breakDownGraphConfig";
import map from "lodash/map";
import get from "lodash/get";

const BreakDownGraphGrid = ({ stats = [], label, id }) => {
  const containerRef = useRef(null);
  const chartRef = useRef(null);

  const colors = useMemo(() => map(stats, s => get(s, "color")), [stats]);

  useEffect(() => {
    if (!containerRef.current) return;

    const chart = breakDownGraphConfig(containerRef.current, colors);
    chart.render();
    chartRef.current = chart;

    return () => chart?.destroy();
  }, [colors]);

  useEffect(() => {
    if (chartRef.current && stats.length) {
      chartRef.current.changeData(stats);
    }
  }, [stats]);

  return (
    <>
      <h3 className="text-lg font-bold mb-8 text-black-1">{label}</h3>
      <div ref={containerRef} id={id} className="h-96 w-full" />
    </>
  );
};

export default BreakDownGraphGrid;
